import React, { ReactElement } from 'react';
import { FormControl, Input, IconButton, InputAdornment } from '@material-ui/core';
import { Search, Close } from '@material-ui/icons';

interface ISearchBarProps {
  classes: { [key: string]: string };
  searchText: string;
  handleSearchText: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void
  clearSearchText: () => void;
}

export const SearchBar = ({ classes, searchText, handleSearchText, clearSearchText }: ISearchBarProps): ReactElement => {
  return (
    <FormControl className={classes.searchFormControl}>
      <Input
        id="input-with-icon-adornment"
        fullWidth
        value={searchText}
        onChange={handleSearchText}
        startAdornment={(
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        )}
        endAdornment={(
          <InputAdornment position="end">
            <IconButton
              aria-label="clear-search"
              onClick={clearSearchText}
              edge="end"
            >
              <Close />
            </IconButton>
          </InputAdornment>
        )}
      />
    </FormControl>
  );
};
